export const PRICE = '23 USD'

export const heroBenefits = [
  {
    label: 'Clear Guidance',
    description: 'Know what to try next instead of guessing.',
  },
  {
    label: 'Practical Tools',
    description: 'Schedules and easy-reference pages you actually use.',
  },
  {
    label: 'Age-by-Age Support',
    description: 'From birth to 24 months, stage by stage.',
  },
]

export const painPoints = [
  '20-Minute Naps',
  'Bedtime Battles',
  'Constant Night Waking',
  'Schedules That Suddenly Stop Working',
]

export const guides = [
  {
    number: '01',
    title: 'The Age-by-Age Schedules',
    description: 'Know what a realistic daily rhythm can look like at each stage.',
    accent: '#E9DFCF',
  },
  {
    number: '02',
    title: 'The Sleep Environment Lab',
    description: 'Create a calmer environment for better sleep.',
    accent: '#CCD5C2',
  },
  {
    number: '03',
    title: 'The Gentle Training Methods',
    description: 'Practical, gentle approaches for building lasting sleep habits.',
    accent: '#DFC0BC',
  },
  {
    number: '04',
    title: 'The Nap Mastery Guide',
    description: 'Understand nap timing, transitions and common nap challenges.',
    accent: '#EFDCB4',
  },
  {
    number: '05',
    title: 'The Night Feed Weaning Guide',
    description: 'Structured guidance for approaching night-feed transitions.',
    accent: '#D9D3E3',
  },
  {
    number: '06',
    title: 'The Regression Shield',
    description: 'Tools for navigating changing sleep phases.',
    accent: '#CEDFEB',
  },
]

/**
 * A LOOK INSIDE — real interior pages of The Baby Sleep Bible.
 * Large page first, then the overlapping ones. PDF or image sources both work.
 */
export const insidePages: { src: string; caption: string }[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/d85uF2H98vuZCA8PqTRPCd/Pag_23_bebe.pdf',
    caption: 'Customizing for Early & Late Wakers',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/kPEeTcvjrVjB5JbHo28BSD/Pag_10_bebe.pdf',
    caption: 'The Core Pattern: Eat, Play, Sleep',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/6k3Lptch5vp4Fi2xEconKo/Pag_26_bebe.pdf',
    caption: '7–12 Months: The Two-Nap Golden Age',
  },
]

/**
 * SAMPLE testimonials — editable placeholder copy for design purposes.
 * Replace names, countries and quotes with real feedback before publishing.
 */
export const testimonials = [
  {
    quote:
      'I was constantly searching for wake windows and second-guessing our nap schedule. Having everything organized in one place made it so much easier to know what to try next.',
    name: 'Emily Carter',
    country: 'United States',
  },
  {
    quote:
      'The age-by-age schedules are what I use the most. Instead of reading ten different articles every time something changes, I know exactly where to look.',
    name: 'Sophie Bennett',
    country: 'United Kingdom',
  },
  {
    quote:
      'What I love most is how practical it is. I can quickly check the guide during the day instead of trying to remember everything I have read online.',
    name: 'Olivia Martin',
    country: 'Canada',
  },
]

export const offerIncludes = [
  '6 Digital Guides',
  'Age-by-age wake windows and nap times',
  'Simple routines from birth to 24 months',
  'Instant digital access, yours to keep',
]

export const faqs = [
  {
    question: 'Is The Baby Sleep Bible a physical product?',
    answer:
      'No. It is a digital bundle of six downloadable guides. Nothing is shipped — you receive instant access after purchase and can keep the files.',
  },
  {
    question: 'What ages is it designed for?',
    answer:
      'Birth to 24 months. Schedules, wake windows and routines are organized by stage, so you only read the part that matches your baby right now.',
  },
  {
    question: 'Do I need to read all six guides?',
    answer:
      'No. Most parents start with the Age-by-Age Schedules and then open whichever guide matches what they are dealing with — naps, night feeds, environment or a regression.',
  },
  {
    question: 'Can I read it on my phone or tablet?',
    answer:
      'Yes. The guides are PDFs designed for easy reference, so you can check them on your phone during the day or print the pages you use most.',
  },
  {
    question: 'Is this medical advice?',
    answer:
      'No. The Baby Sleep Bible is an educational resource. It does not replace advice from your pediatrician or healthcare provider, and every baby is different.',
  },
  {
    question: 'What if it is not what I expected?',
    answer:
      'You are covered by a 7-day money-back guarantee. If the guides are not the right fit, write to us within 7 days of your purchase and we will refund you in full.',
  },
]

export const GUARANTEE_TITLE = '7-Day Money-Back Guarantee'
export const GUARANTEE_TEXT =
  'Read the guides, try the schedules. If The Baby Sleep Bible is not the right fit for your family, write to us within 7 days of your purchase and we will refund you in full.'
